import { getBase64ImageType } from "../components/utils";

export function getHeaderLogo(logoUrl: string | null): string {
    // content property NIET weghalen, anders wordt de logo niet getoond
    return  `@page {
      @top-right {
        content:'';
        background: url('${logoUrl ? `data:image/${getBase64ImageType(logoUrl)};base64,${logoUrl}` : '/images/blinqx-logo-black-v2.svg'}');
        background-position-x: right;
        background-position-y: center;     
        background-repeat: no-repeat;
        background-size:120px;
        height: 90px;
        z-index:9999;
        }
    }`
  }

/* istanbul ignore next */
export function getFooter(footerText: string | null, hideOnFirstPage = false): string {
  if (!footerText) {
    return '';
  }

  return `
  @page {
    @bottom-center {
      font-size: 0.6rem;
      text-align: center;
      white-space: pre-wrap;
      display:block;
      margin-top:10px;
      max-width: 500px;
      content: '${footerText}';
    }
  }
  
  @page :first  {
    @bottom-center {
      content: '${hideOnFirstPage && footerText ? '' : footerText}';
    }
  }
  `;
}
